import { Link } from "@tanstack/react-router";
import type { Post } from "../types";
import { getReadingMinutes } from "../lib/posts";
import { TagPill } from "./TagPill";

export function PostCard({ post }: { post: Post }) {
  const date = post.published_at ?? post.created_at;

  return (
    <article className="post-card">
      <div className="post-thumb" aria-hidden="true">
        {post.cover_image_url ? <img src={post.cover_image_url} alt="" /> : <span>&gt;_</span>}
      </div>
      <div className="post-body">
        <div className="post-tags">
          {(post.tags ?? []).slice(0, 3).map((tag) => (
            <TagPill key={tag.slug} tag={tag} />
          ))}
        </div>
        <h3>
          <Link className="card-link" params={{ slug: post.slug }} to="/post/$slug">
            {post.title}
          </Link>
        </h3>
        <p>{post.summary}</p>
        <small>
          {new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
          }).format(new Date(date))}{" "}
          · {getReadingMinutes(post.content)} min read
        </small>
      </div>
      <span className="post-arrow" aria-hidden="true">
        →
      </span>
    </article>
  );
}
